import { render, staticRenderFns } from "./ApprovalClaim.vue?vue&type=template&id=67ae5a6e&"
import script from "./ApprovalClaim.vue?vue&type=script&lang=js&"
export * from "./ApprovalClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports